import BaseRepository from './BaseRepository';

export default class HotelsRepository extends BaseRepository
{
    getEndpoint()
    {
        return 'hotels';
    }
    featured()
    {
        return this.request('GET', `${this.getEndpoint()}/featured`, null);
    }

    offers()
    {
        return this.request('GET', `${this.getEndpoint()}/offers`, null);
    }

    latest()
    {
        return this.request('GET', `${this.getEndpoint()}/latest`, null);
    }

    searchHotels(criteria)
    {
        return this.request('GET', `${this.getEndpoint()}/searchHotels/${criteria}`, null);
    }

    getBySlug(slug)
    {
        return this.request('GET', `${this.getEndpoint()}/getBySlug/${slug}`, null);
    }

    getHotelRoomsBySlug(slug)
    {
        return this.request('GET', `${this.getEndpoint()}/get-hotel-rooms-by-slug/${slug}`, null);
    }
}
